import { useEffect, useRef, useState } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { IDriverDetail, IDriverSearchFields, service } from './service'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'
import { globalPrompt } from '@/components/message'
import { ModoulTypeList } from '@/types/TcoDs'
import { message } from 'antd'

export const baseModel = createModel(function () {
    const settingTypeList = ModoulTypeList
    /**
     * 列表
     */
    //列表数据源
    const [dataSource, setDataSource] = useState<IDriverDetail[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<IDriverSearchFields>({})
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<IDriverDetail>({})
    //编辑详情form
    const [detailEditForm, setDetailEditForm] = useState<IDriverDetail>({})
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<IDriverDetail[]>([])
    const [SelectedId, setSelectedId] = useState('')
    //对账明细打开页面
    const [detailVisible, setDetailVisible] = useState(false)
    //新增，编辑状态判断
    const [mode, setMode] = useState<'add' | 'edit'>('add')
    //对账明细打开页面
    const [addCarVisible, setAddCarVisible] = useState(false)
    const [editCarVisible, setEditCarVisible] = useState<any>({
        visible: false,
        value: {},
    })

    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg)
    //新增详情form
    const [totalNum, setTotalNum] = useState<any>({})
    const {
        user: { shopCode },
        fetchDriverList,
    } = useGlobalModel(({ user }) => [user])
    const [loading, setLoading] = useState<boolean>(false)
    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])
    //列表查询
    const loadData = async (page: ISearchPage = pgCfgRef.current, searchValue: IDriverSearchFields = searchParam) => {
        setLoading(true)
        const searchParams = {
            ...searchValue,
            createUserId: shopCode,
            type: '巡查员',
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await service.page(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(records)
        setLoading(false)
        fetchDriverList()
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IDriverSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        setSelectedRowKeys([])
        loadData(initPgCfg, {})
    }
    //删除巡查员
    const onDelete = (record: IDriverDetail) => {
        globalPrompt('modal', {
            title: '删除巡查员',
            type: 'warning',
            text: '您正在删除巡查员是否确认删除？',
            okText: '确认',
            onOk: async () => {
                let list = record.map((item: { id: string }) => {
                    return { id: item.id }
                })
                let insertRet = await service.onDelete(list)
                if (insertRet.success) {
                    message.success('删除成功!')
                } else {
                    message.success('删除失败!' + insertRet.retMsg)
                }
                loadData()
            },
            cancelText: '取消',
            onCancel: () => {
                return
            },
        })
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        detailVisible,
        detailEditForm,
        detailAddForm,
        mode,
        SelectedId,
        settingTypeList,
        totalNum,
        loading,
        addCarVisible,
        editCarVisible,
        initPgCfg,
        /***method***/
        setEditCarVisible,
        setAddCarVisible,
        setLoading,
        setTotalNum,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        setDetailVisible,
        setDetailEditForm,
        setDetailAddForm,
        setMode,
        setSelectedId,
        onDelete,
    }
})
